import config from '../../config/generated.json'

function isDefaultProductCardStyle(): boolean {
  return config.ui.productCardStyle === 'default'
}

export default isDefaultProductCardStyle
